import React, { ReactNode } from "react";
import Button from "./Button";

type Cell = string | number | ReactNode;

export type TableData = {
  columns: string[];
  data: Cell[][];
};

type FlexibleTableProps = {
  title?: string;
  data: TableData;
  sticky: boolean;
  amount: number;
};

export default function FlexibleTable({
  title,
  data,
  sticky,
  amount,
}: FlexibleTableProps): JSX.Element {
  const { columns, data: rows } = data;

  if (!columns || columns.length === 0) {
    return <div>No columns</div>;
  }

  return (
    <>
      <div className='flex justify-between items-center gap-1'>
        <h3 className={`${title ? `w-1/4` : ''} font-bold text-2xl dark:text-black`}>{title}</h3>
        
      </div>
      <div className="table-max-height p-0 overflow-x-scroll overflow-y-scroll relative">
        <table className="data-table text-left border-spacing-x-5">
          <thead>
            <tr className="th-readability sticky top-0 z-10 bg-white odd:text-black dark:odd:bg-ngray dark:even:bg-ndarkgray">
              {columns.map((col, index) => (
                <th
                  key={index}
                  className={`sticky-items ${index < amount && sticky ? `sticky table-item-left-${index + 1}` : ""
                    }`}
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.map((row, rowIndex) => {
              const isFailed = row[row.length - 1] === 1;
              return(
              <tr
                key={rowIndex}
                className={`tbody-readability dark:even:text-ndgray bg-white dark:bg-ndarkgray dark:odd:bg-ngray ${
                          isFailed ? "line-through text-red-500" : ""
                        }`}
              >
                {row.map((cell, colIndex) => {
                  return(<td
                    key={colIndex}
                    className={`sticky-items ${colIndex < amount && sticky ? `sticky table-item-left-${colIndex + 1}` : ""
                      }`}
                  >
                    {cell}
                  </td>)
                })}
              </tr>
            )})}
          </tbody>
        </table>
      </div>
    </>
  );
}
